import React, { useEffect } from "react";
import Collapse from '@material-ui/core/Collapse';
import { Grid, Fade } from '@material-ui/core';
import PotControl from './PotControl';
import PotLegend from './components/PotLegend';
import { LargeButton } from './components/Buttons';
import SpinningCogWheels from './components/SpinningCogWheels';

const PotContainer = (props) => {
    const hasLegend = props.Pots && props.Pots.length > 0 && props.Pots[0].hasDetails;
    const showLegend = props.Pots && props.Pots.length > 0 && props.Pots[0].showDetails;
    const { vm, state, localState, setLocalState } = props;
    const handleButtons = () => {
        if (state.CanBuyData) {
            if (showLegend) {
                setTimeout(
                    function () {
                        setLocalState({ showBuyDataButton: true });
                    },
                    150
                );
            } else {
                setTimeout(
                    function () {
                        setLocalState({ showBuyDataButton: false });
                    },
                    50
                );
            }
        }
        if (state.CanChangePriceplan && state.IsData) {
            if (showLegend) {
                setTimeout(
                    function () {
                        setLocalState({ showChangeDataLevelButton: true });
                    },
                    150
                );
            } else {
                setTimeout(
                    function () {
                        setLocalState({ showChangeDataLevelButton: false });
                    },
                    50
                );
            }
        }    }
    useEffect(() => {
        setLocalState({ showBuyDataButton: state.CanBuyData && !showLegend });
        setLocalState({ showChangeDataLevelButton: state.CanChangePriceplan && state.IsData && !showLegend });
    }, [state.CanBuyData])
    return (
        <React.Fragment>
            <Grid container direction="column" justify="center" alignItems="center" style={{ cursor: hasLegend ? 'pointer' : 'auto' }} onClick={() => { if (hasLegend) { handleButtons(); vm.$dispatch({ ToggleDetails: 1 }); } }}>
                {!props.Pots &&
                    <React.Fragment>
                        <SpinningCogWheels style={{ height: '199px' }} />
                    </React.Fragment>}
                <Grid container direction="row" justify="center" alignItems="center">
                    {props.Pots && props.Pots.map((pot) => {
                        var multiple = false;
                        if (props.Pots.length > 1) {
                            multiple = true;
                        }
                        return (
                            <PotControl key={pot.index}
                                Pot={pot}
                                multiple={multiple}
                            />
                        );
                    })
                    }
                </Grid>
                <div style={{ width: '100%', maxWidth: '450px' }}>
                    <Collapse in={showLegend}>
                        <Grid container direction="row" justify="center" alignItems="center" style={{ paddingTop: '10px', width: '100%', maxWidth: '450px', background: '#FFFFFF 0% 0% no-repeat padding-box', boxShadow: '0px 5px 10px #76767629', borderRadius: '14px', marginTop: '17px' }} >
                            {hasLegend && props.Pots[0].legends.map((legend) => {
                                return (
                                    <PotLegend key={legend.index}
                                        PotLegend={legend}
                                    />
                                );
                            })
                            }

                        </Grid>
                    </Collapse>
                </div>
                {props.Pots && props.Pots.length > 0 &&
                    <div style={{ fontSize: '10px', lineHeight: '14px', fontWeight: 300, fontStyle: 'normal', marginTop: '10px' }}><span dangerouslySetInnerHTML={{ __html: props.Pots[0].label3 }} /></div>
                }
            </Grid>
            <Fade in={localState.showBuyDataButton} style={{ display: localState.showBuyDataButton ? 'block' : 'none' }}>
                <LargeButton style={{ margin: '17px 0px 13px' }} onClick={() => { props.handleBuyData(); } }>+ Bestill datapakke</LargeButton>
            </Fade>
            <Fade in={localState.showChangeDataLevelButton} style={{ display: localState.showChangeDataLevelButton ? 'block' : 'none' }}>
                <LargeButton style={{ margin: '17px 0px 13px' }} onClick={() => { props.handleChangeDataLevel(); }}>Endre datagrense</LargeButton>
            </Fade>
        </React.Fragment >
    );
}

export default PotContainer;